import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getXmlFormats = createAsyncThunk("xmlFormats/getXmlFormats", async () => {
  try {
    const response = await magnifiAPI.getXmlFormats();

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateXmlDetails = createAsyncThunk("xmlFormats/updateXmlDetails", async (payload) => {
  try {
    const response = await magnifiAPI.updateXmlDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
